import styled from 'styled-components';

export const DropdownWrapper = styled.div`
  position: relative;
  z-index: 3;
`;
